import { Button, Container, Typography, Box, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export const Home = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg">
      <Box textAlign="center" py={8} minHeight="100vh" display="flex" flexDirection="column" justifyContent="center">
        {/* Hero Section */}
        <Box mb={8}>
          {/* Hero Section with Background */}
          <Box 
            sx={{
              position: 'relative',
              mb: 6,
              minHeight: '400px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: 'linear-gradient(135deg, rgba(139, 43, 226, 0.6), rgba(255, 0, 110, 0.6), rgba(0, 245, 255, 0.6)), radial-gradient(circle at center, rgba(209, 52, 110, 0.8) 0%, transparent 70%)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                opacity: 0.7,
                zIndex: -1,
                borderRadius: '15px'
              }
            }}
          >
            <Typography 
              variant="h2" 
              component="h1"
              className="glitch"
              gutterBottom
              sx={{ 
                fontSize: { xs: '3rem', md: '5rem' },
                mb: 2,
                fontFamily: 'Orbitron, sans-serif',
                position: 'relative',
                zIndex: 1
              }}
            >
              NAME STORE
            </Typography>
            
            <Typography 
              variant="h4" 
              component="p"
              className="neon-flicker"
              sx={{ 
                color: '#40c4cc',
                mb: 4,
                fontFamily: 'Share Tech Mono, monospace',
                fontSize: { xs: '1.2rem', md: '1.5rem' },
                textShadow: '0 0 8px rgba(64, 196, 204, 0.3)',
                position: 'relative',
                zIndex: 1
              }}
            >
              Где встречаются стиль и технологии
            </Typography>
          </Box>
        </Box>

        {/* Hero Buttons */}
        <Box display="flex" justifyContent="center" gap={3} mb={8} flexWrap="wrap">
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/catalog')}
            sx={{ 
              px: 4,
              py: 2,
              fontSize: '1.1rem',
              fontWeight: 600,
              textTransform: 'none',
              borderRadius: '50px',
              background: 'linear-gradient(135deg, #b8306a, #6d3fb3, #3d6cc7)',
              boxShadow: '0 5px 15px rgba(209, 52, 110, 0.3)',
              '&:hover': {
                transform: 'translateY(-3px)',
                boxShadow: '0 8px 25px rgba(209, 52, 110, 0.4)',
                background: 'linear-gradient(135deg, #a02859, #5e3492, #325aa6)',
              }
            }}
          >
            Исследуйте наш ассортимент
          </Button>
          <Button
            variant="outlined"
            size="large"
            onClick={() => navigate('/catalog')}
            sx={{ 
              px: 4,
              py: 2,
              fontSize: '1.1rem',
              fontWeight: 600,
              textTransform: 'none',
              borderRadius: '50px',
              borderColor: '#d1346e',
              color: '#e0e0e0',
              position: 'relative',
              overflow: 'hidden',
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: '-100%',
                width: '100%',
                height: '100%',
                background: 'linear-gradient(135deg, #b8306a, #6d3fb3, #3d6cc7)',
                transition: 'left 0.3s ease',
                zIndex: -1,
              },
              '&:hover': {
                color: 'white',
                borderColor: 'transparent',
                '&::before': {
                  left: 0,
                }
              }
            }}
          >
            Смотреть специальности
          </Button>
        </Box>

        {/* Introduction Card */}
        <Paper 
          className="shimmer"
          sx={{ 
            p: 4, 
            mb: 6,
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: 'url(/images/intro-background.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              opacity: 0.4,
              zIndex: 0,
              borderRadius: '3px'
            },
            background: 'rgba(20, 20, 20, 0.7)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(209, 52, 110, 0.2)',
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(209, 52, 110, 0.3)',
            maxWidth: '800px',
            mx: 'auto'
          }}
        >
          <Typography 
            variant="h5" 
            gutterBottom
            sx={{ 
              color: '#d1346e',
              mb: 3,
              fontFamily: 'Orbitron, sans-serif',
              fontWeight: 700,
              letterSpacing: 1,
              position: 'relative',
              zIndex: 1
            }}
          >
            Добро пожаловать в цифровую революцию покупок
          </Typography>
          <Typography 
            variant="body1" 
            paragraph
            sx={{ 
              color: '#e0e0e0',
              fontSize: '1.1rem',
              lineHeight: 1.8,
              mb: 2,
              position: 'relative',
              zIndex: 1
            }}
          >
            В 2045 году NAME STORE возник из цифровых теней, чтобы переопределить опыт покупок. Наш квантовый процесс подбора и системы на базе ИИ создают покупки, которые существуют между измерениями стиля и сознания.
          </Typography>
          <Typography 
            variant="body1" 
            sx={{ 
              color: '#9a9a9a',
              fontSize: '1rem',
              lineHeight: 1.6,
              position: 'relative',
              zIndex: 1
            }}
          >
            Каждая покупка рассказывает историю инноваций, бунта и неустанного поиска идеального стиля. Войдите в нашу матрицу и почувствуйте будущее.
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
};
